export default "__VITE_ASSET__e0354970__"